<template>
    <div class="vvdieo">
        <div class="img" style="background: #0092e5;" @click="goshow">
            <!-- <van-icon name="play-circle-o" :color="color" size="1rem" style="position:absolute;top:50%;z-index: 999;left:50%;transform:translate(-50%,-50%);"/> -->
            <van-image :src="imgurl" style="display: block;" :height="height" :width="width" :fit="fit"/>
        </div>
        <Popup v-model="showVideo" @close="onclose" closeable position="bottom" :style="{ height: '100%' }">
            <video id="video" :src="videoUrl" controls x5-video-player-type="h5" playsinline="true" x5-playsinline="true" autoplay webkit-playsinline="true" height="100%" width="100%">您的浏览器不支持播放该视频！</video>
        </Popup>
    </div>
</template>
<script>
    import {Icon, Image, Popup,ImagePreview} from 'vant';

    export default {
        data() {
            return {
                showVideo: false,
                showImage: false,
                imgs:[]
            }
        },
        filters:{
            Img(val){
                try {
                    val = JSON.parse(val)
                    return val[0]
                }catch (e) {
                    console.log(e)

                }
            }
        },
        components: {
            Icon,
            VanImage: Image,
            Popup,
            [ImagePreview.Component.name]: ImagePreview.Component,
        },
        props: {
            'mediaType':{
                type:Number,
                default:1
            },
            'height': String,
            'width': String,
            'videoUrl': String,
            'imgurl': String,
            'fit':{
                type: String,
                default: "cover"
            },
            'color': {
                type: String,
                default: "#393940"
            },
        },
        methods: {
           goshow(){
             this.showVideo=true
             setTimeout(function(){
               var video = document.querySelector('#video');
               video.play();
             }, 1000);


           },
           onclose() {
            var video = document.querySelector('#video');
               video.pause();
           },
            playVideo: function () {
                window.location.href = this.videoUrl
            }
        }
    }
</script>
<style lang="less" scoped>
.vvdieo{
    .img{
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
